import React from 'react';
import { useTranslation } from 'react-i18next';
import { Reveal } from '../motion/Reveal';

const ITEMS = [
  { src: '/assets/lumi/merch/14_Lumi_plush_toy_15cm.webp', key: 'plush' },
  { src: '/assets/lumi/merch/15_Lumi_plush_keychain_carabiner_8cm.webp', key: 'keychain' },
  { src: '/assets/lumi/merch/13_Lumi_stickers_new_set.webp', key: 'stickers' },
  { src: '/assets/lumi/merch/12_Lumi_pins_new_5_designs.webp', key: 'pins' }
];

const LumiMerchStrip = () => {
  const { t } = useTranslation();
  return (
    <section className="lumi-merch" id="lumi-irl" aria-label={t('lumi.merch.title')}>
      <div className="container">
        <Reveal>
          <h2 className="home-odam-h2">{t('lumi.merch.title')}</h2>
          <p className="home-odam-lead">{t('lumi.merch.subtitle')}</p>
        </Reveal>
        <ul className="lumi-merch__row">
          {ITEMS.map((item) => (
            <li key={item.key}>
              <img
                src={item.src}
                alt={t(`lumi.merch.items.${item.key}`, { defaultValue: t('lumi.merch.title') })}
                width="320"
                height="320"
                loading="lazy"
                decoding="async"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default LumiMerchStrip;
